import React from 'react';

import { Cards, Charts , CountryPicker } from './components';
import styles from './App.module.css';
import {fetchData} from './api';

import coronaImage from './images/image.png';

class App extends React.Component {

    state = {
        data: {},
        country: '',
    }

    async componentDidMount() {
        const fetchedData = await fetchData();
        this.setState({ data:fetchedData });
    }

    handleCountryChange = async(country) => {

        //fetch the data
        const fetchedData = await fetchData(country);
        
        this.setState({ data: fetchedData,
                country: country,
            });
        //set the state
        
    }

    render() {

        //destructue data for cards
        const { data,country } = this.state;

        return(<div className={styles.container}>
            <img src={coronaImage} className={styles.image} alt="Covid_19 Image"/>
            <Cards data={this.state.data}/>
            <CountryPicker handleCountryChange = {this.handleCountryChange}/>
            <Charts data={data} country={country} />
        </div>)
    }
}

export default App;

/* axios for fetching api
    react-chartjs-2 for visualizing through charts
    react-countup for animations of count of cases

    */

